import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules, validationRules } from '@/support/ValidationRules';
import { Material } from '@/models/Material';
import { cloneDeep } from 'lodash';

@Component<CreateDialog>({})
export default class CreateDialog extends Vue {
  @Prop({default: null})
  protected material!: Material;

  protected newMaterial: Material = new Material();

  protected isLoading: boolean = true;

  protected valid: boolean = false;

  protected rules: Rules = EnglishRules;

  mounted() {
    if(this.material) {
      this.newMaterial = cloneDeep(this.material);
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }


  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected createOrUpdate() {
    if(this.newMaterial.id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected update() {
    this.isLoading = true;
    if(!this.material) {
      return;
    }

    this.newMaterial
      .update()
      .then((material: Material) => {
        this.isLoading = false;
        this.$emit('materialUpdated', material);
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected create() {
    if (!this.canSaveMaterial) {
      return;
    }

    this.isLoading = true;
    this.newMaterial
    .create()
    .then((material: Material) => {
      this.isLoading = false;
      this.$emit('materialCreated');
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected get canSaveMaterial() {
    if(this.newMaterial && this.newMaterial.name && this.newMaterial.name.length > 0) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    if(this.newMaterial && this.newMaterial.id) {
      return 'Edit';
    }

    return 'Add';
  }

  protected clear() {
    this.newMaterial = new Material();
  }
}
